<template>
  <v-container>
    <v-card-actions>
      <employee-leaves-applications-dialog-create
        :employee-uid="employee.employee_uid"
        @created="loadApplications"
      />
    </v-card-actions>
    <v-row no-gutters>
      <v-col
        cols="12"
      >
        <employee-leaves-entitlements-card-view-list
          ref="entitlement"
          :employee-uid="employee.employee_uid"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="$vuetify.breakpoint.mdAndUp"
      no-gutters
    >
      <v-col
        cols="12"
      >
        <employee-leaves-applications-table-list
          ref="application"
          :employee-uid="employee.employee_uid"
          @cancelled="loadEntitlements"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      EmployeeLeavesApplicationsDialogCreate: () => import('@/components/employee/leaves/applications/DialogCreate'),
      EmployeeLeavesEntitlementsCardViewList: () => import('@/components/employee/leaves/entitlements/CardViewList'),
      EmployeeLeavesApplicationsTableList: () => import('@/components/employee/leaves/applications/TableList'),
    },
    metaInfo () {
      return {
        title: 'My Leave',        
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
    methods: {
      loadApplications () {
        this.$refs.application.loadLeaveApplications()
      },
      loadEntitlements () {
        this.$refs.entitlement.loadEntitlements()
      },
    },
  }
</script>
